import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import * as CartActions from '../../../store/cart/cart.actions';
import * as fromApp from '../../../store/app.reducers';

import { ApplicationConstants } from '../../../constants/application-constants';
import { CartItem, CartSampling } from '../../../model/cart.model';
import { SetSamplingSuppliesQuantityError } from '../../../store/layout/layout.actions';
import { UtilFunctions } from '../../../utils/util-functions';

import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
    selector: 'app-quantity-input',
    templateUrl: './quantity-input.component.html',
    styleUrls: ['./quantity-input.component.scss']
})
export class QuantityInputComponent implements OnInit, OnChanges {

    @Input() modelField: number;
    @Output() modelFieldChange: EventEmitter<number> = new EventEmitter();
    @Input() isCartItem = false;
    @Input() cartItem: CartItem;
    @Input() isProduct = false;
    @Input() isProductInCart = false;
    @Input() sampling: CartSampling;

    public decreaseButtonDisabled: boolean;
    public increaseButtonDisabled: boolean;


    maxQuantity: number;
    oldValue: number;

    constructor(
        private store: Store<fromApp.AppState>,
        private notification: NzNotificationService
    ) {
    }

    ngOnInit() {
        this.oldValue = this.modelField;
        this.maxQuantity = ApplicationConstants.MAX_QUANTITY;
    }

    ngOnChanges() {
        this.decreaseButtonDisabled = (this.isCartItem ? this.modelField === 1 :
            this.isProductInCart ? this.modelField === 0 : this.modelField === 1);
        this.increaseButtonDisabled = (this.modelField === this.maxQuantity);
    }

    increaseQuantity() {
        if (this.isCartItem) {
            const cartItem = JSON.parse(JSON.stringify(this.cartItem));
            cartItem.quantity = Math.min(this.modelField + 1, this.maxQuantity);
            this.store.dispatch(new CartActions.UpdateCartItem(cartItem, this.sampling));
        } else {
            this.modelField = Math.min(this.modelField + 1, this.maxQuantity);
            this.modelFieldChange.emit(this.modelField);
        }
    }

    decreaseQuantity() {
        if (this.isCartItem) {
            const cartItem = JSON.parse(JSON.stringify(this.cartItem));
            cartItem.quantity = Math.max(this.modelField - 1, 1);
            this.store.dispatch(new CartActions.UpdateCartItem(cartItem, this.sampling));
        } else {
            this.modelField = Math.max(this.modelField - 1, this.isProductInCart ? 0 : 1);
            this.modelFieldChange.emit(this.modelField);
        }
    }

    setOldValue() {
        this.oldValue = this.modelField;
    }

    updateFromInput() {
        if (!UtilFunctions.isInt(this.modelField)) {
            this.modelField = this.oldValue;
        }
        if (this.modelField > this.maxQuantity) {
            const message = `You cannot order more than ${this.maxQuantity} items.  ` +
          `Please call us on ${ApplicationConstants.PHONE} if you require more.`;
            this.store.dispatch(
                new SetSamplingSuppliesQuantityError(true)
            );

            this.notification.info('Maximum Quantity', message);

        }

        this.modelField = Math.min(Math.max(this.modelField, this.isCartItem ? 1 : 0), this.maxQuantity);
        this.modelFieldChange.emit(this.modelField);
        if (this.isCartItem) {
            let cartItem = JSON.parse(JSON.stringify(this.cartItem));
            cartItem = { ...cartItem, quantity: this.modelField };
            cartItem.quantity = this.modelField;
            this.store.dispatch(new CartActions.UpdateCartItem(cartItem, this.sampling));
        }
        setTimeout(() => {
            this.store.dispatch(
                new SetSamplingSuppliesQuantityError(false)
            );
        }, 1200);
    }
}
